<template>
  <div class="end-page u-w12of12 u-bg-white-off u-relative">
    <div class="u-center">
      <div class="u-inline-block u-w6of12 u-w10of12-sm u-blue">
        <div class="t-h3 u-marg-t-lg">
          {{ data.titre }}
        </div>
        <div class="t-text u-marg-t-md">
          {{ data.titre }}
        </div>
      </div>
    </div>
    <div class="u-row u-center u-marg-t-lg">
      <router-link :to="page.href" class="u-w2of12 u-marg-x-lg" v-for="(page, index) in data.brightPages" :key="index">
        <div class="end-page__shadow u-box-1by1 u-round u-overflow-hidden">
          <app-image class="u-wrapper-panel" :width="400" :height="400" :id="page.image[0].id" />
        </div>
        <div class="t-text--small u-marg-t-md">
          {{ page.label }}
        </div>
      </router-link>
    </div>
    <strates v-if="loaded" :data="data.brightStrates" />
  </div>
</template>

<script>

import Strates from '@/components/strates/Strates'

export default {
  metaInfo () {
    return {
      link: [
        { rel: 'canonical', href: 'https://brig.ht/end-page' }
      ]
    }
  },
  components: {
    Strates,
  },

  computed: {
    data () {
      return this.$store.getters['data/endPage']
    },
    loaded () {
      return this.$store.getters['data/loaded']
    }
  },

  created () {
    this.onInit()
  },

  methods: {
    onInit () {
      this.$store.dispatch('data/endPage')
    }
  },

  watch: {
    $route () {
      this.onInit()
    }
  }
}
</script>

<style lang="stylus">
.end-page
  &__shadow
    box-shadow 0px 0px 25px 10px rgba(0 0 0 .1)
</style>